function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { isCustomRange, parseCustomRange, makeCustomRange, customRangeLabel } from "../views/sales/territory-common";

/*
 * Platform date-range picker (CUSTOM_DATE_RANGES.md Phase C).
 * The preset select gains a "Custom range…" entry; picking it reveals
 * from/to date inputs + Apply, emitting the `custom_YYYYMMDD_YYYYMMDD`
 * token through the SAME onChange the presets use — pages route it like
 * any range (`/{range}` segments accept it).
 *
 * Validation: start ≤ end, end ≤ today, window ≤ 36 months (the backend
 * contract). Data-floor lookup ("data begins {date}") is a follow-up —
 * v1 relies on honest empty states for pre-history windows.
 *
 * props: value · onChange(token) · ranges [[token,label],...]
 */
export default class RangePicker extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSelect", e => {
      const v = e.target.value;
      if (v === "__custom__") {
        const today = new Date();
        const monthAgo = new Date(today);
        monthAgo.setDate(monthAgo.getDate() - 30);
        const iso = d => d.toISOString().slice(0, 10);
        this.setState({
          editing: true,
          error: "",
          from: this.state.from || iso(monthAgo),
          to: this.state.to || iso(today)
        });
        return;
      }
      this.setState({
        editing: false,
        error: ""
      });
      this.props.onChange(v);
    });
    _defineProperty(this, "apply", () => {
      const {
        from,
        to
      } = this.state;
      if (!from || !to) {
        this.setState({
          error: "Pick both dates."
        });
        return;
      }
      const start = new Date(from + "T00:00:00");
      const end = new Date(to + "T00:00:00");
      const today = new Date();
      today.setHours(23, 59, 59);
      if (start > end) {
        this.setState({
          error: "Start must be before end."
        });
        return;
      }
      if (end > today) {
        this.setState({
          error: "End can't be in the future."
        });
        return;
      }
      if ((end - start) / 86400000 > 36 * 31) {
        this.setState({
          error: "Window is capped at 36 months."
        });
        return;
      }
      this.setState({
        editing: false,
        error: ""
      });
      this.props.onChange(makeCustomRange(from, to));
    });
    const w = parseCustomRange(props.value);
    const _iso = d => d.toISOString().slice(0, 10);
    this.state = {
      editing: false,
      from: w ? _iso(w[0]) : "",
      to: w ? _iso(w[1]) : "",
      error: ""
    };
  }
  render() {
    const {
      value,
      ranges
    } = this.props;
    const {
      editing,
      from,
      to,
      error
    } = this.state;
    const custom = isCustomRange(value);
    return /*#__PURE__*/React.createElement("span", {
      className: "range-picker"
    }, /*#__PURE__*/React.createElement("select", {
      className: "territory-range",
      value: custom && !editing ? "__customActive__" : editing ? "__custom__" : value,
      onChange: this.onSelect
    }, ranges.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l)), custom && !editing && /*#__PURE__*/React.createElement("option", {
      value: "__customActive__"
    }, customRangeLabel(value)), /*#__PURE__*/React.createElement("option", {
      value: "__custom__"
    }, "Custom range\u2026")), editing && /*#__PURE__*/React.createElement("span", {
      className: "range-picker-custom"
    }, /*#__PURE__*/React.createElement("input", {
      type: "date",
      className: "territory-range",
      value: from,
      onChange: e => this.setState({
        from: e.target.value,
        editing: true
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "range-picker-sep"
    }, "\u2013"), /*#__PURE__*/React.createElement("input", {
      type: "date",
      className: "territory-range",
      value: to,
      onChange: e => this.setState({
        to: e.target.value,
        editing: true
      })
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      onClick: this.apply
    }, "Apply"), error && /*#__PURE__*/React.createElement("span", {
      className: "range-picker-err"
    }, error)));
  }
}